import React from "react";
import {createStyles, makeStyles, StyledComponentProps, Theme} from "@material-ui/core";

interface ReactProps {
    children: React.ReactNode
}

const useStyles = makeStyles((theme: Theme) => createStyles({
    addContainer: {
    	display: "flex",
        padding: theme.spacing(2),
        textAlign: "right",
		justifyContent: "space-between",
    }
}));

type IProps = ReactProps & StyledComponentProps;

const AddMultiContainer:React.FC<IProps> = (props:IProps) => {
    const classes = useStyles();
    return (
        <div className={classes.addContainer}>
            {props.children}
        </div>
    );
};

export default AddMultiContainer;